/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import {IModelBase} from "./i-model-base";

export class ModelBase implements IModelBase {
  name: string = "";
  id: string = "";
  active: boolean = false;
  created: Date = new Date();
  modified: Date = new Date();
  publicName: string | undefined = undefined;
}
